export interface OfficerData {
  name: string
  date: string
  loginMin: number
  readyMin: number
  notReadyMin: number
  ringingMin: number
  onCallMin: number
  afterCallWorkMin: number
  leadsConverted: number // leads turned into active applications today
  submissions: number // loan files sent to underwriting today (a.k.a. "subs")
}

// 37 loan officers. Output (leads + submissions) now matters as much as time-effort.
// Notable archetypes embedded:
//  - Officer #25: "Hidden gem" — middling time stats, strong output → jumps to Pacesetter
//  - Officer #20: "Warm phone" — high focus %, zero output → flagged Needs Coaching
//  - Officer #38: partial reporting case, zero output → flagged
export const mockOfficers: OfficerData[] = [
  // — high-effort, high-output (Pacesetter-tier on both dimensions) —
  {
    name: 'Avery Sterling',
    date: '2026-05-09',
    loginMin: 475,
    readyMin: 110,
    notReadyMin: 38,
    ringingMin: 7,
    onCallMin: 295,
    afterCallWorkMin: 25,
    leadsConverted: 8,
    submissions: 5,
  },
  {
    name: 'Jordan Blake',
    date: '2026-05-09',
    loginMin: 480,
    readyMin: 120,
    notReadyMin: 45,
    ringingMin: 8,
    onCallMin: 285,
    afterCallWorkMin: 22,
    leadsConverted: 7,
    submissions: 4,
  },
  {
    name: 'Morgan Reed',
    date: '2026-05-09',
    loginMin: 485,
    readyMin: 125,
    notReadyMin: 42,
    ringingMin: 6,
    onCallMin: 288,
    afterCallWorkMin: 24,
    leadsConverted: 8,
    submissions: 5,
  },
  {
    name: 'Riley Carter',
    date: '2026-05-09',
    loginMin: 478,
    readyMin: 115,
    notReadyMin: 40,
    ringingMin: 8,
    onCallMin: 290,
    afterCallWorkMin: 25,
    leadsConverted: 7,
    submissions: 4,
  },
  {
    name: 'Taylor Brooks',
    date: '2026-05-09',
    loginMin: 480,
    readyMin: 105,
    notReadyMin: 42,
    ringingMin: 10,
    onCallMin: 300,
    afterCallWorkMin: 23,
    leadsConverted: 8,
    submissions: 5,
  },
  {
    name: 'Casey Bennett',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 115,
    notReadyMin: 38,
    ringingMin: 6,
    onCallMin: 285,
    afterCallWorkMin: 26,
    leadsConverted: 7,
    submissions: 4,
  },
  {
    name: 'Quinn Harper',
    date: '2026-05-09',
    loginMin: 485,
    readyMin: 110,
    notReadyMin: 42,
    ringingMin: 7,
    onCallMin: 298,
    afterCallWorkMin: 28,
    leadsConverted: 9,
    submissions: 5,
  },
  {
    name: 'Skyler Hayes',
    date: '2026-05-09',
    loginMin: 475,
    readyMin: 122,
    notReadyMin: 40,
    ringingMin: 7,
    onCallMin: 282,
    afterCallWorkMin: 24,
    leadsConverted: 7,
    submissions: 4,
  },
  {
    name: 'Dakota Rivera',
    date: '2026-05-09',
    loginMin: 482,
    readyMin: 110,
    notReadyMin: 43,
    ringingMin: 7,
    onCallMin: 295,
    afterCallWorkMin: 27,
    leadsConverted: 6,
    submissions: 4,
  },

  // — mid effort, mid output (Climbing) —
  {
    name: 'Hayden Cross',
    date: '2026-05-09',
    loginMin: 490,
    readyMin: 85,
    notReadyMin: 52,
    ringingMin: 9,
    onCallMin: 310,
    afterCallWorkMin: 34,
    leadsConverted: 6,
    submissions: 3,
  },
  {
    name: 'Peyton Lane',
    date: '2026-05-09',
    loginMin: 465,
    readyMin: 95,
    notReadyMin: 60,
    ringingMin: 6,
    onCallMin: 275,
    afterCallWorkMin: 29,
    leadsConverted: 5,
    submissions: 3,
  },
  {
    name: 'Drew Sullivan',
    date: '2026-05-09',
    loginMin: 455,
    readyMin: 100,
    notReadyMin: 50,
    ringingMin: 5,
    onCallMin: 260,
    afterCallWorkMin: 30,
    leadsConverted: 4,
    submissions: 2,
  },
  {
    name: 'Emerson Wells',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 78,
    notReadyMin: 55,
    ringingMin: 8,
    onCallMin: 298,
    afterCallWorkMin: 31,
    leadsConverted: 5,
    submissions: 3,
  },
  {
    name: 'Rowan Pierce',
    date: '2026-05-09',
    loginMin: 460,
    readyMin: 80,
    notReadyMin: 70,
    ringingMin: 8,
    onCallMin: 270,
    afterCallWorkMin: 32,
    leadsConverted: 4,
    submissions: 2,
  },
  {
    name: 'Sage Mitchell',
    date: '2026-05-09',
    loginMin: 475,
    readyMin: 85,
    notReadyMin: 65,
    ringingMin: 10,
    onCallMin: 280,
    afterCallWorkMin: 35,
    leadsConverted: 5,
    submissions: 2,
  },
  {
    name: 'Reese Coleman',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 92,
    notReadyMin: 67,
    ringingMin: 8,
    onCallMin: 268,
    afterCallWorkMin: 35,
    leadsConverted: 4,
    submissions: 2,
  },
  {
    name: 'Finley Grant',
    date: '2026-05-09',
    loginMin: 485,
    readyMin: 70,
    notReadyMin: 75,
    ringingMin: 7,
    onCallMin: 295,
    afterCallWorkMin: 38,
    leadsConverted: 5,
    submissions: 3,
  },
  {
    name: 'Harlow Reeves',
    date: '2026-05-09',
    loginMin: 460,
    readyMin: 80,
    notReadyMin: 70,
    ringingMin: 8,
    onCallMin: 270,
    afterCallWorkMin: 32,
    leadsConverted: 3,
    submissions: 1,
  },
  {
    name: 'Marlowe Quinn',
    date: '2026-05-09',
    loginMin: 478,
    readyMin: 75,
    notReadyMin: 70,
    ringingMin: 7,
    onCallMin: 290,
    afterCallWorkMin: 36,
    leadsConverted: 4,
    submissions: 2,
  },
  // ↓ Officer #20: WARM PHONE archetype — high focus %, zero output
  {
    name: 'Phoenix Adler',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 88,
    notReadyMin: 70,
    ringingMin: 9,
    onCallMin: 275,
    afterCallWorkMin: 28,
    leadsConverted: 0,
    submissions: 0,
  },
  {
    name: 'Tatum Vaughn',
    date: '2026-05-09',
    loginMin: 480,
    readyMin: 78,
    notReadyMin: 72,
    ringingMin: 8,
    onCallMin: 290,
    afterCallWorkMin: 32,
    leadsConverted: 4,
    submissions: 2,
  },
  {
    name: 'Sloane Decker',
    date: '2026-05-09',
    loginMin: 465,
    readyMin: 95,
    notReadyMin: 65,
    ringingMin: 8,
    onCallMin: 265,
    afterCallWorkMin: 32,
    leadsConverted: 5,
    submissions: 3,
  },
  {
    name: 'Beckett Shaw',
    date: '2026-05-09',
    loginMin: 475,
    readyMin: 80,
    notReadyMin: 70,
    ringingMin: 7,
    onCallMin: 280,
    afterCallWorkMin: 38,
    leadsConverted: 3,
    submissions: 2,
  },
  {
    name: 'Wren Caldwell',
    date: '2026-05-09',
    loginMin: 480,
    readyMin: 75,
    notReadyMin: 70,
    ringingMin: 7,
    onCallMin: 290,
    afterCallWorkMin: 38,
    leadsConverted: 4,
    submissions: 2,
  },
  {
    name: 'Hollis Barrett',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 85,
    notReadyMin: 72,
    ringingMin: 7,
    onCallMin: 270,
    afterCallWorkMin: 36,
    leadsConverted: 3,
    submissions: 1,
  },

  // — modest effort, modest output (Steady) — except the hidden gem
  // ↓ Officer #25: HIDDEN GEM — middling time stats, big output → jumps to Pacesetter
  {
    name: 'Ellis Monroe',
    date: '2026-05-09',
    loginMin: 460,
    readyMin: 0,
    notReadyMin: 65,
    ringingMin: 7,
    onCallMin: 265,
    afterCallWorkMin: 28,
    leadsConverted: 7,
    submissions: 4,
  },
  {
    name: 'Sawyer Floyd',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 65,
    notReadyMin: 105,
    ringingMin: 10,
    onCallMin: 245,
    afterCallWorkMin: 45,
    leadsConverted: 3,
    submissions: 1,
  },
  {
    name: 'Lennox Page',
    date: '2026-05-09',
    loginMin: 475,
    readyMin: 70,
    notReadyMin: 105,
    ringingMin: 10,
    onCallMin: 240,
    afterCallWorkMin: 50,
    leadsConverted: 2,
    submissions: 1,
  },
  {
    name: 'Remy Dalton',
    date: '2026-05-09',
    loginMin: 460,
    readyMin: 75,
    notReadyMin: 105,
    ringingMin: 10,
    onCallMin: 220,
    afterCallWorkMin: 50,
    leadsConverted: 3,
    submissions: 1,
  },
  {
    name: 'Arden Holt',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 70,
    notReadyMin: 115,
    ringingMin: 10,
    onCallMin: 230,
    afterCallWorkMin: 45,
    leadsConverted: 2,
    submissions: 1,
  },
  {
    name: 'Briar Lowe',
    date: '2026-05-09',
    loginMin: 465,
    readyMin: 80,
    notReadyMin: 110,
    ringingMin: 7,
    onCallMin: 220,
    afterCallWorkMin: 48,
    leadsConverted: 3,
    submissions: 1,
  },
  {
    name: 'Indigo Frost',
    date: '2026-05-09',
    loginMin: 455,
    readyMin: 70,
    notReadyMin: 110,
    ringingMin: 10,
    onCallMin: 215,
    afterCallWorkMin: 50,
    leadsConverted: 2,
    submissions: 0,
  },
  {
    name: 'Kendall Pryce',
    date: '2026-05-09',
    loginMin: 460,
    readyMin: 70,
    notReadyMin: 105,
    ringingMin: 10,
    onCallMin: 225,
    afterCallWorkMin: 50,
    leadsConverted: 3,
    submissions: 1,
  },

  // — Needs Coaching tier on both dimensions —
  {
    name: 'Oakley Vance',
    date: '2026-05-09',
    loginMin: 460,
    readyMin: 35,
    notReadyMin: 175,
    ringingMin: 10,
    onCallMin: 180,
    afterCallWorkMin: 60,
    leadsConverted: 1,
    submissions: 0,
  },
  {
    name: 'Sterling Boyd',
    date: '2026-05-09',
    loginMin: 450,
    readyMin: 40,
    notReadyMin: 180,
    ringingMin: 10,
    onCallMin: 165,
    afterCallWorkMin: 55,
    leadsConverted: 2,
    submissions: 1,
  },
  {
    name: 'Marley Stone',
    date: '2026-05-09',
    loginMin: 470,
    readyMin: 45,
    notReadyMin: 180,
    ringingMin: 10,
    onCallMin: 170,
    afterCallWorkMin: 65,
    leadsConverted: 1,
    submissions: 0,
  },
  {
    name: 'Rory Calloway',
    date: '2026-05-09',
    loginMin: 810,
    readyMin: 0,
    notReadyMin: 810,
    ringingMin: 0,
    onCallMin: 0,
    afterCallWorkMin: 0,
    leadsConverted: 0,
    submissions: 0,
  },
]

// Prior-day Production Score for each officer — used for "Best Climb" and per-officer trend.
// (Production Score blends 40% effort + 60% output, capped at 100.)
export const priorDayProduction: Record<string, number> = {
  'Avery Sterling': 88.5,
  'Jordan Blake': 84.0,
  'Morgan Reed': 87.2,
  'Riley Carter': 83.5,
  'Taylor Brooks': 88.0,
  'Casey Bennett': 82.0,
  'Quinn Harper': 88.4,
  'Skyler Hayes': 82.5,
  'Dakota Rivera': 80.0,
  'Hayden Cross': 81.5,
  'Peyton Lane': 75.0,
  'Drew Sullivan': 65.5,
  'Emerson Wells': 75.5,
  'Rowan Pierce': 64.0,
  'Sage Mitchell': 67.0,
  'Reese Coleman': 63.5,
  'Finley Grant': 76.5,
  'Harlow Reeves': 52.0,
  'Marlowe Quinn': 65.0,
  'Phoenix Adler': 70.0, // yesterday Climbing — today's "warm phone" is a sharp dip
  'Tatum Vaughn': 65.5,
  'Sloane Decker': 76.0,
  'Beckett Shaw': 60.0,
  'Wren Caldwell': 65.5,
  'Hollis Barrett': 50.5,
  'Ellis Monroe': 62.0, // yesterday Steady — today's hidden gem
  'Sawyer Floyd': 51.5,
  'Lennox Page': 46.0,
  'Remy Dalton': 50.5,
  'Arden Holt': 46.5,
  'Briar Lowe': 51.0,
  'Indigo Frost': 38.5,
  'Kendall Pryce': 50.0,
  'Oakley Vance': 30.0,
  'Sterling Boyd': 36.0,
  'Marley Stone': 28.5,
  'Rory Calloway': 8.0,
}

export const priorDayTeamStats = {
  totalBorrowerMin: 8800,
  totalAvailableMin: 2950,
  totalWrapUpMin: 1280,
  totalLeads: 138, // lower than today's ~160
  totalSubmissions: 68, // lower than today's ~85
  avgProductionScore: 60.5,
  avgOffQueueRatio: 0.165,
}
